import React, { useCallback, useRef, useState } from "react";

import { RxCross2 } from "react-icons/rx";
import { LuUploadCloud } from "react-icons/lu";
import Modal from "./Modal";
import PrimaryBtn, { SecondaryBtn } from "./Button";
import { BiImageAdd } from "react-icons/bi";
import { GoImage } from "react-icons/go";
// import AttachmentLink from "src/components/Admin/AttachmentLink";

export function ImagePreview({ setFieldValue, values, isService }) {
  function removeFile(ind) {
    let files = [...values];
    files.splice(ind, 1);
    setFieldValue(`images`, files);
  }

  // const links = values.filter((f) => typeof f === "string");

  // const other = values.filter((f) => typeof f !== "string");

  const handleAdd = (value) => {
    setFieldValue(`images`, value);
  };

  return (
    <div className="py-2 flex gap-2 items-center flex-wrap">
      <FileUpload
        attachments={values}
        setAttachments={(value) => handleAdd(value)}
        removeFile={removeFile}
        isService={isService}
      />
    </div>
  );
}

function FileUpload({
  attachments,
  removeFile,
  setAttachments,
  isService,
}: {
  attachments: [any];
  setAttachments: any;
  removeFile: (index: number) => void;
  isService: boolean;
}) {
  const [error, setError] = useState("");
  const [imageModal, setImageModal] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  // Function to handle file and store it to file state
  const imageRef = useRef(null);
  const handleFileChange = (e) => {
    setError("");
    // const maxSize = 15 * 1024 * 1024;
    const temp = [...e.target?.files];
    if (temp?.length + attachments?.length > 5 && selectedImage != null) {
      setError("You can add upto 5 images");
      return;
    }

    if (
      isService &&
      temp?.length + attachments?.length > 1 &&
      selectedImage != null
    ) {
      setError("You can add only 1 image");
      return;
    }

    // let result = [...temp, ...attachments];
    // setImageModal(false);
    // setAttachments(result);
    let fileExtention = temp?.[0]?.name.split(".").pop();
    if (
      fileExtention?.toLowerCase() !== "jpg" &&
      fileExtention?.toLowerCase() !== "jpeg" &&
      fileExtention?.toLowerCase() !== "svg" &&
      fileExtention?.toLowerCase() !== "png" &&
      fileExtention?.toLowerCase() !== "webp"
    ) {
      setError(
        "Invalid file type. Only jpg, png, svg, webp and jpeg files are allowed."
      );
      return;
    }
    setUploadFile(temp?.[0]);
  };
  const handleClick = () => {
    setImageModal(true);
    //imageRef?.current?.click();
  };
  const handleDragOver = useCallback((event: any) => {
    event.preventDefault(); // Prevent default behavior (Prevent file from being opened)
    setDragOver(true);
  }, []);

  const handleDragLeave = useCallback((event: any) => {
    event.preventDefault();
    setDragOver(false);
  }, []);
  const handleDrop = useCallback((event: any) => {
    event.preventDefault();
    setDragOver(false);
    const files = event.dataTransfer.files;
    if (files.length) {
      const file = files[0];
      if (file.type.startsWith("image/")) {
        // If the file is an image, handle the upload
        let fileExtention = file.name.split(".").pop();
        if (
          fileExtention?.toLowerCase() !== "jpg" &&
          fileExtention?.toLowerCase() !== "jpeg" &&
          fileExtention?.toLowerCase() !== "svg" &&
          fileExtention?.toLowerCase() !== "png" &&
          fileExtention?.toLowerCase() !== "webp"
        ) {
          setError(
            "Invalid file type. Only jpg, png, svg, webp and jpeg files are allowed."
          );
          return;
        }
        setUploadFile(file);
        // setImageModal(false);
        // setAttachments([...attachments, file]);
      } else {
        setError("Please drop an image file.");
      }
    }
  }, []);

  const handleImageClick = () => {
    imageRef?.current?.click();
  };

  const handleClose = () => {
    setImageModal(false);
    setUploadFile(null);
    setSelectedImage(null);
  };
  const handleUpload = () => {
    if (selectedImage != null) {
      attachments[selectedImage] = uploadFile;
    } else {
      attachments.push(uploadFile);
    }
    setAttachments([...attachments]);
    handleClose();
  };

  return (
    <div className="relative w-full">
      {imageModal && (
        <Modal
          title="Upload Images"
          description={`You can add up to ${isService ? 1 : 5} images per ${
            isService ? "service" : "product"
          }.`}
          central={true}
          handleClose={handleClose}
        >
          <div className="mt-2">
            <ImageModalDesign
              dragOver={dragOver}
              handleDragOver={handleDragOver}
              handleDragLeave={handleDragLeave}
              handleDrop={handleDrop}
              handleClick={handleImageClick}
              handleClose={handleClose}
              handleUpload={handleUpload}
              uploadFile={uploadFile}
              setUploadFile={setUploadFile}
              error={error}
            />
          </div>
        </Modal>
      )}

      <div
        className="h-52 w-full  border border-dotted border-customGrey-border2 rounded-lg flex justify-center items-center text-xl text-gray-400 cursor-pointer mb-3"
        onClick={() => {
          handleClick();
          attachments[0] && setSelectedImage(0);
        }}
      >
        <Attachment
          key={0}
          attachment={attachments[0]}
          removeFile={() => removeFile(0)}
        />
      </div>

      {!isService && (
        <div className="grid grid-cols-4 gap-3">
          {[1, 2, 3, 4].map((item) => (
            <div
              className="w-16 h-16 border border-dotted rounded-lg flex justify-center items-center text-xl text-gray-400 cursor-pointer"
              onClick={() => {
                handleClick();
                attachments[item] && setSelectedImage(item);
              }}
            >
              <Attachment
                key={item}
                attachment={attachments[item]}
                removeFile={() => removeFile(item)}
              />
            </div>
          ))}
        </div>
      )}
      {/* <span className="py-1 text-red-600 text-xs">{error}</span> */}
      <input
        type="file"
        id={`image`}
        onChange={handleFileChange}
        multiple
        className="hidden"
        ref={imageRef}
      />
    </div>
  );
}
const ImageModalDesign = ({
  dragOver,
  handleDragOver,
  handleDragLeave,
  handleDrop,
  handleClick,
  handleClose,
  handleUpload,
  uploadFile,
  setUploadFile,
  error,
}) => {
  return (
    <div>
      <div
        className={
          "border rounded-lg cursor-pointer  " +
          (dragOver ? " border-customGreen-primary" : "border-gray-300")
        }
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={handleClick}
      >
        {!uploadFile ? (
          <div className=" px-10 pt-10 pb-2">
            <div className="grid justify-center mb-2">
              <LuUploadCloud className="text-4xl text-gray-600 bg-gray-100 rounded-full p-1" />
            </div>
            <div className="text-sm  text-center px-4">
              <span className=" text-customGreen-primary font-semibold">
                Click to Upload
              </span>{" "}
              or drag and drop <br />
              SVG,PNG,JPG,JPEG or Webp
            </div>
          </div>
        ) : (
          <div className="group relative  text-customPurple-400  max-w-[338px] max-h-[170px] flex items-center justify-center cursor-pointer ">
            <img
              src={
                typeof uploadFile === "string"
                  ? uploadFile
                  : URL.createObjectURL(uploadFile)
              }
              alt="Cover Photo"
              className="inset-0 w-auto object-fit h-auto max-w-[336px] max-h-[168px]"
            />
            <div
              className="hidden group-hover:inline-block absolute -top-3 -right-3 m-0.5 p-0.5 bg-customPurple-400 rounded-full cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setUploadFile(null);
              }}
            >
              <RxCross2 className="text-red-600 bg-white rounded-full border border-gray-100" />
            </div>
          </div>
        )}
      </div>
      <span className="py-1 text-red-600 text-xs">{error}</span>
      <div className=" grid grid-cols-2 gap-4 mt-4">
        <SecondaryBtn
          text="Cancel"
          onClick={() => {
            handleClose();
          }}
        />
        <PrimaryBtn
          text="Upload"
          onClick={handleUpload}
          disabled={!uploadFile}
        />
      </div>
    </div>
  );
};

const Attachment = ({ attachment, removeFile }) => {
  if (!attachment) {
    return <BiImageAdd className=" text-gray-300" />;
  }

  const src =
    typeof attachment === "string"
      ? attachment
      : URL.createObjectURL(attachment);

  return (
    <div className="group relative border border-customPurple-400 text-customPurple-400 size-full overflow-hidden  rounded-lg flex items-center justify-center cursor-pointer ">
      <img
        src={src}
        alt="Cover Photo"
        className={`object-fill contain-content"`}
      />
      <div
        className="hidden group-hover:inline-block absolute -top-1 -right-1 m-0.5 p-0.5 bg-customPurple-400 rounded-full cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          removeFile();
        }}
      >
        <RxCross2 className="text-red-600 bg-white rounded-full border border-gray-100" />
      </div>
    </div>
  );
};
type Props = {
  setFieldValue: any;
  values: any;
  name: string;
  label: string;
  isTask?: boolean;
  companyModal?: boolean;
};

export const SingleImageUplaod = ({
  setFieldValue,
  values,
  name,
  label,
  isTask = false,
  companyModal,
}: Props) => {
  const [error, setError] = useState("");
  // Function to handle file and store it to file state
  const imageRef = useRef<any>(null);
  const [dragOver, setDragOver] = useState(false);

  const handleDragOver = useCallback((event: any) => {
    event.preventDefault(); // Prevent default behavior (Prevent file from being opened)
    setDragOver(true);
  }, []);

  const handleDragLeave = useCallback((event: any) => {
    event.preventDefault();
    setDragOver(false);
  }, []);

  const isValidFileExtension = (fileExtension, isTask) => {
    const imageExtensions = ["jpg", "jpeg", "svg", "png", "webp"];
    const documentExtensions = ["docx", "doc", "pdf", "xlsx", "xls"];

    const allowedExtensions = isTask
      ? [...imageExtensions, ...documentExtensions]
      : imageExtensions;

    return allowedExtensions.includes(fileExtension?.toLowerCase());
  };

  const handleFileChange = (e: any) => {
    setError("");
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      let fileExtension = file.name.split(".").pop();

      if (!isValidFileExtension(fileExtension, isTask)) {
        setError(
          !isTask
            ? "Invalid file type. Only jpg, png, svg, webp and jpeg files are allowed."
            : "Invalid file type. Only SVG, PNG, JPG or PDF, DOC, XLXS files are allowed."
        );
        removeFile();
        return;
      }

      setFieldValue(name + "_file", e.target.files[0]);
    }
    e.target.value = null;
  };

  const isValidFileType = (fileType, isTask) => {
    if (fileType.startsWith("image/")) {
      return true;
    }

    if (
      isTask &&
      (fileType.startsWith("text/") || fileType.startsWith("application/"))
    ) {
      return true;
    }

    // If it doesn't match the allowed conditions, it's invalid
    return false;
  };
  const handleDrop = useCallback((event: any) => {
    event.preventDefault();
    setDragOver(false);
    const files = event.dataTransfer.files;
    if (files.length) {
      const file = files[0];
      if (isValidFileType(file.type, isTask)) {
        // If the file is an image, handle the upload      let fileExtension = file.name.split(".").pop();
        let fileExtention = file.name.split(".").pop();
        if (!isValidFileExtension(fileExtention, isTask)) {
          setError(
            "Invalid file type. Only jpg, png, svg, webp and jpeg files are allowed."
          );
          removeFile();
          return;
        }
        setFieldValue(name + "_file", file);
      } else {
        setError(
          !isTask
            ? "Please drop an image file."
            : "Please drop an image or document file"
        );
        return;
      }

      setFieldValue("image", [...(values.image || []), file]);
    }
  }, []);

  const handleClick = () => {
    imageRef?.current?.click();
  };

  function removeFile() {
    setFieldValue(name, "");
    setFieldValue(name + "_file", null);
  }

  return (
    <div className="relative ">
      <div
        className={
          "border rounded-lg cursor-pointer " +
          (dragOver ? " border-customGreen-primary" : "border-gray-200")
        }
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={handleClick}
      >
        {/* {!values[name] && !values[name + "_file"] ? ( */}
        <div className="px-10 py-4">
          <div className=" rounded-full w-12 h-12 mx-auto flex justify-center items-center mb-2">
            {" "}
            {companyModal ? (
              <div className="rounded-full w-12 h-12 overflow-hidden">
                {!values.company_logo && !values.company_logo_file ? (
                  <GoImage
                    className={`text-3xl text-customGreen-primary bg-customGreen-dark p-2 rounded-full w-fit h-fit `}
                  />
                ) : (
                  <img
                    src={
                      values.company_logo_file
                        ? URL.createObjectURL(values.company_logo_file)
                        : values.company_logo
                    }
                    alt="company logo"
                    className="w-full h-full object-cover"
                  />
                )}
              </div>
            ) : (
              <div className="bg-gray-50 rounded-full w-12 h-12 grid justify-center items-center">
                <div className="bg-gray-100 rounded-full w-9 h-9 grid justify-center items-center">
                  <LuUploadCloud className="text-2xl text-gray-600" />
                </div>
              </div>
            )}
          </div>
          <div className="text-center text-sm text-customGrey-text">
            <span className="text-customGreen-primary font-semibold">
              Click to Upload
            </span>{" "}
            <span className="text-sm text-customGrey-text space-y-1">
              or drag and drop <br />
              {`SVG,PNG,JPG,JPEG or Webp `}
            </span>
            <span className="text-xs mt-1 inline-block">{`(max 800x400px)`}</span>
          </div>
        </div>
        {/* ) : (
          <div className="group relative  text-customPurple-400  max-w-[338px] max-h-[170px] flex items-center justify-center cursor-pointer ">
            <img
              src={
                values[name]
                  ? values[name]
                  : URL.createObjectURL(values[name + "_file"])
              }
              alt="Cover Photo"
              className="inset-0 w-auto object-fit h-auto max-w-[336px] max-h-[168px]"
            />
            <div
              className="hidden group-hover:inline-block absolute -top-3 -right-3 m-0.5 p-0.5 bg-customPurple-400 rounded-full cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                removeFile();
              }}
            >
              <RxCross2 className="text-red-600 bg-white rounded-full border border-gray-100" />
            </div>
          </div>
        )} */}
      </div>
      <div className="text-sm font-normal py-2">{label}</div>

      <p className="text-sm text-red-500">{error}</p>
      <input
        type="file"
        id={`image`}
        onChange={handleFileChange}
        className="hidden"
        ref={imageRef}
      />
    </div>
  );
};
